import './ImpressumComponentSkeleton.scss';

const ImpressumComponentSkeleton = () => {

    return (
        <div className="impressum__wrapper__skeleton">
            {[...Array(4)].map((_, index) => (
                <div key={index} className='impressum__rules__item__skeleton'>
                    <div className='impressum__rules__item__title__wrapper__skeleton'>
                        <div className="impressum__rules__item__title__skeleton"></div>
                    </div>
                    <div className='impressum__rules__item__content__wrapper__skeleton'>
                        {[...Array(3)].map((_, index) => (
                            <div key={index} className='impressum__rules__item__content__skeleton'></div>
                        ))}
                        <div className='impressum__rules__item__content__skeleton--primary'></div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ImpressumComponentSkeleton;